import React from 'react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const CasosSucessoPage = () => {
  const cases = Array.from({ length: 9 }).map((_, index) => ({
    name: `Cliente ${index + 1}`,
    segment: ['Distribuidoras', 'Varejo', 'Alimentos', 'Autopeças'][index % 4],
    challenge: 'Operação fragmentada e baixa visibilidade.',
    solution: 'ERP + APP + BI integrados.',
    result: '+25% eficiência operacional.'
  }));

  return (
    <div>
      <PageHero
        eyebrow="Casos de sucesso"
        title="Resultados reais em todo o Brasil."
        subtitle="Clientes que reduziram custos, venderam mais e ganharam controle total."
        primaryCta={{ label: 'Agendar demo', href: '/demonstracao' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Filtros"
            title="Selecione o segmento"
            description="Veja cases por setor para comparar resultados."
          />
          <div className="flex flex-wrap gap-3 justify-center mb-10">
            {['Todos', 'Distribuidoras', 'Autopeças', 'Alimentos', 'Varejo'].map((item) => (
              <button key={item} className="px-4 py-2 rounded-full border border-white/10 bg-white/5 text-sm font-semibold">
                {item}
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cases.map((item) => (
              <Card key={item.name}>
                <h3 className="text-xl font-semibold">{item.name}</h3>
                <p className="text-sm text-slate-200/70">{item.segment}</p>
                <div className="mt-4 space-y-2 text-sm text-slate-200/80">
                  <p><strong>Desafio:</strong> {item.challenge}</p>
                  <p><strong>Solução:</strong> {item.solution}</p>
                  <p><strong>Resultados:</strong> {item.result}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CasosSucessoPage;
